import { useMutation } from "react-query";
import { addSafeMake } from "../../../../../actions/Utilities/SafeMake";
import { toast } from "components/toastNotification";
import { ISafeMake } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { addStateSafeMake, safeMakeReFetching } from "../atoms/atoms";

const useAddSafeMake = () => {
  const setActionAddState = useSetRecoilState(addStateSafeMake);
  const [isReFetching, setIsReFetching] = useRecoilState(safeMakeReFetching);
  const { mutate } = useMutation((NewData: ISafeMake) => addSafeMake(NewData), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Adding Safe Make failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Safe Make Added Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Safe Make Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Adding Safe Make failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Adding Safe Make failed",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          default:
            toast.fire("Adding Safe Make failed", res, "error");
        }
      }
      // Redirect to View
      setActionAddState(false);

      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },

    onError: (error: any) => {
      toast.fire("Add Safe Make failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
};
export default useAddSafeMake;
